import React, { useEffect, useRef } from "react";

// Sticky banner at the top of every page. It publishes its height as the
// --banner-h CSS variable so the sticky Header can sit just below it.
const AnnouncementBar = () => {
  const barRef = useRef(null);

  useEffect(() => {
    const root = document.documentElement;
    const observer = new ResizeObserver(([entry]) => {
      root.style.setProperty(
        "--banner-h",
        `${entry.target.offsetHeight}px`
      );
    });
    observer.observe(barRef.current);
    return () => {
      observer.disconnect();
      root.style.removeProperty("--banner-h");
    };
  }, []);

  return (
    <div
      ref={barRef}
      className="sticky top-0 z-[60] w-full bg-[#F1EDFB] px-4 py-[7px] sm:py-[10px]"
    >
      <h4 className="text-center font-[450] text-[#131E3D] text-[12px] sm:text-[15px] leading-[17px] sm:leading-[20px]">
        The Dangote IPO has been screened to be Shariah Compliant and it’s now
        live on the Halvest App. Subscribe today!
      </h4>
    </div>
  );
};

export default AnnouncementBar;
